import './toast-wrap.styles.scss';

export default angular.module('directives.abToastWrap', [])
  .directive('abToastWrap', () => {
    'ngInject';

    return {
      restrict: 'E',
      replace: true,
      templateUrl: require('./toast-wrap.template.html'),
    };
  })
  .name;
